import { CircleCheck, CircleSlash } from "lucide-react";
import { describeRule } from "../emailOptionsText";
import type { EmailDirection, EmailOptionsActivity, EmailOptionsSettings } from "../types";

type WorkflowSummaryProps = {
  settings: EmailOptionsSettings;
  activities: EmailOptionsActivity[];
};

const directions: EmailDirection[] = ["inbound", "outbound"];

/** Reads the current choices back in plain English, so the outcome is clear before saving. */
export const WorkflowSummary = ({ settings, activities }: WorkflowSummaryProps) => {
  if (!settings.autoCreateTask) {
    return (
      <ul className="grid gap-2">
        <SummaryLine createsTask={false}>Emails are filed against the customer. No tasks are created.</SummaryLine>
      </ul>
    );
  }

  return (
    <ul className="grid gap-2">
      {directions.map(direction => (
        <SummaryLine key={direction} createsTask={!!settings[direction].activityId}>
          {describeRule(direction, settings[direction], activities)}
        </SummaryLine>
      ))}
    </ul>
  );
};

const SummaryLine = ({ createsTask, children }: { createsTask: boolean; children: string }) => {
  const Icon = createsTask ? CircleCheck : CircleSlash;
  return (
    <li className="flex list-none items-start gap-2 text-sm">
      <Icon className={createsTask ? "mt-0.5 size-4 shrink-0 text-success" : "mt-0.5 size-4 shrink-0 text-muted-foreground"} aria-hidden />
      <span>{children}</span>
    </li>
  );
};
